import { login, getCurrentUser, logout } from '@/api/login/index.js'
import { Toast } from 'vant';
const user = {
  state: {
    id: '',
    name: '',
    avatar: '',
    phone: '',
    token: '',
    userInfo: {}
  },

  mutations: {

    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
  },

  actions: {
    // 用户名登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response.data;
          commit('SET_TOKEN', data.token);
          localStorage.setItem("Authorization",data.token)
          localStorage.setItem("userInfo",JSON.stringify(data.userInfo))
          //window.location.replace("/");
          //this.$router.go(-1)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息，相关权限数据
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 请求获取权限 -> 通过token查询
        getCurrentUser().then(response => {

          if (!response.data) {
            reject('Verification failed, please login again.')
          }
          const data = response.data

          commit('SET_ID', data.id)
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.avatar)
          commit('SET_PHONE', data.phone)
          commit('SET_USERINFO', data)

          resolve(response)
        }).catch(error => {
		  console.log(error,'嘿嘿嘿，我抓到你了')
          reject(error)
        })
      })
    },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '');
          localStorage.removeItem("Authorization")
          // 注销QQ
          // QC.Login.signOut();
          //removeToken();
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        localStorage.removeItem("Authorization")
        // 注销

        resolve()
      })
    }

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js